/* ════ DISPLAY NAME ════════════════════════════════════════ */
// Friendly name from an email: robin.edwards@x.com → "Robin Edwards".
// Non-emails (e.g. "Imported") pass through unchanged.
export function displayName(email) {
  if (!email) return '';
  if (!email.includes('@')) return email;
  return email.split('@')[0].split(/[._-]+/).filter(Boolean)
    .map(w => w[0].toUpperCase() + w.slice(1)).join(' ');
}
